import styled from "@emotion/styled";
import { FC } from "react";
import { useDispatch } from "react-redux";

import { Button, FormField, Input, SpacingToken, Text, Tooltip } from "@livechat/design-system-react-components";

import { CopyToClipboard } from "components/copy-to-clipboard-input";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { IMailbox } from "store/entities/mailboxes/interfaces";
import { SettingsViewActions } from "store/views/settings";
import { withVar } from "themes/helpers";

import { trackAddressCopied } from "../analytics";

interface IProps {
  inbox: IMailbox | undefined;
  forwardingAddress: string;
}

export const ForwardingAddressDisplay: FC<IProps> = ({ inbox, forwardingAddress }) => {
  const dispatch = useDispatch();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleCopied = () => {
    dispatch(SettingsViewActions.mailboxCopied());
    trackAddressCopied("edit");
  };

  return (
    <StyledFormField labelText="HelpDesk's forwarding address">
      <InputWrapper>
        <Tooltip
          triggerRenderer={() => (
            <Flex gap={withVar(SpacingToken.Spacing2)}>
              <GrowInput disabled value={forwardingAddress} />
              {inbox && (
                <Block>
                  <CopyToClipboard value={forwardingAddress} onCopiedHandler={handleCopied}>
                    {/* TODO: Fix this the next time the file is edited. */}
                    {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                    {({ handleCopy }: any) => (
                      <Button kind="secondary" onClick={handleCopy}>
                        Copy
                      </Button>
                    )}
                  </CopyToClipboard>
                </Block>
              )}
            </Flex>
          )}
          isVisible={!inbox ? undefined : false}
          kind="invert"
          placement="top"
        >
          <Text>Complete adding this forwarding address before using it.</Text>
        </Tooltip>
      </InputWrapper>
    </StyledFormField>
  );
};

const InputWrapper = styled.div`
  display: flex;
  width: 100%;

  & > div {
    flex: 1;
  }
`;

const GrowInput = styled(Input)`
  flex: 1;
`;

const StyledFormField = styled(FormField)`
  margin: 0;
  width: 100%;
`;
